<template>
  <div class="nav-bar">
    <div class="left-button">
      <button class="button-com" @click="handleScroll(240)">＜</button>
    </div>
    <div class="scroll-outer" ref="scrollOuter" @DOMMouseScroll="handlescroll" @mousewheel="handlescroll">
      <div class="scroll-body" ref="scrollBody" :style="{left: tagBodyLeft + 'px'}">
        <div v-for="item in tabList" class="tag-ct" :class="{'current':isCurrentTag(item)}" :key="item.name"
          @click="onTagClick(item)" ref="tagsPageOpened">
          <span class="dot"></span>
          <span style="font-size:14px;">{{item.label}}</span>
          <i class="close" v-if="item.closable" @click.stop="onCloseClick(item)">×</i>
        </div>
      </div>
    </div>
    <div class="right-button">
      <button class="button-com" @click="handleScroll(-240)">＞</button>
    </div>
    <div class="contextmenu">
      <el-dropdown class="dropDownBtn">
        <i class="el-icon-circle-close"></i>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="handleTagsOption('all')" :disabled="!tabList.length">关闭所有</el-dropdown-item>
          <el-dropdown-item divided @click.native="handleTagsOption('other')" :disabled="tabList.length <= 1">关闭其他</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";

export default {
  data() {
    return {
      tagBodyLeft: 0,
      outerPadding: 4,
    }
  },
  computed: {
    ...mapState("navTabs", ["tabList", "activeTabName"]),
  },
  watch: {
    activeTabName: {
      deep: true,
      immediate: true,
      handler() {
        this.getTagElementByRoute()
      }
    }
  },
  methods: {
    ...mapMutations("navTabs", ["moveTab", "moveAllTab", "moveOtherTab"]),
    isCurrentTag(item) {
      return this.activeTabName == item.name;
    },
    onTagClick(item) {
      if (this.isCurrentTag(item)) return;
      this.$router.push({
        name: item.name
      });
      this.$emit('tag-click', item)
    },
    onCloseClick(item) {
      this.moveTab(item.name)
      this.$emit('tag-close', item)
    },
    getTagElementByRoute() {
      this.$nextTick(() => {
        var nowItem = this.tabList.filter(item => item.name == this.activeTabName)[0];
        var tagIndex = this.tabList.indexOf(nowItem);
        if(tagIndex == -1) return;
        if (this.$refs.tagsPageOpened) {
          let tag = this.$refs.tagsPageOpened[tagIndex];
          this.moveToView(tag);
        }
      })
    },
    moveToView(tag) {
      const outerWidth = this.$refs.scrollOuter.offsetWidth
      const bodyWidth = this.$refs.scrollBody.offsetWidth
      if (bodyWidth < outerWidth) {
        this.tagBodyLeft = 0
      } else if (tag.offsetLeft < -this.tagBodyLeft) {
        // 标签在可视区域左侧
        this.tagBodyLeft = -tag.offsetLeft + this.outerPadding
      } else if (tag.offsetLeft > -this.tagBodyLeft && tag.offsetLeft + tag.offsetWidth < -this.tagBodyLeft + outerWidth) {
        // 标签在可视区域
        this.tagBodyLeft = Math.min(0, outerWidth - tag.offsetWidth - tag.offsetLeft - this.outerPadding)
      } else {
        // 标签在可视区域右侧
        this.tagBodyLeft = -(tag.offsetLeft - (outerWidth - this.outerPadding - tag.offsetWidth))
      }
    },
    handlescroll(e) {
      var type = e.type
      let delta = 0
      if (type === 'DOMMouseScroll' || type === 'mousewheel') {
        delta = (e.wheelDelta) ? e.wheelDelta : -(e.detail || 0) * 40
      }
      this.handleScroll(delta)
    },
    handleScroll(offset) {
      const outerWidth = this.$refs.scrollOuter.offsetWidth
      const bodyWidth = this.$refs.scrollBody.offsetWidth
      if (offset > 0) {
        this.tagBodyLeft = Math.min(0, this.tagBodyLeft + offset)
      } else {
        if (outerWidth < bodyWidth) {
          if (this.tagBodyLeft < -(bodyWidth - outerWidth)) {
            this.tagBodyLeft = this.tagBodyLeft
          } else {
            this.tagBodyLeft = Math.max(this.tagBodyLeft + offset, outerWidth - bodyWidth)
          }
        } else {
          this.tagBodyLeft = 0
        }
      }
    },
    handleTagsOption(type) {
      if (type == 'all') {
        this.moveAllTab();
      } else if (type == 'other') {
        this.moveOtherTab();
      }
      this.tagBodyLeft = 0
    },
  }
}
</script>

<style scoped>
.nav-bar {
  width: 100%;
  height: 40px;
  box-sizing: border-box;
  display: flex;
  margin-bottom: 10px;
  user-select: none;
}
.button-com {
  height: 100%;
  background: #fff;
  line-height: 1;
  width: 30px;
  border: none;
  cursor: pointer;
  border: 1px solid #eee;
}
.button-com:hover {
  color: #409eff;
}
.scroll-outer {
  position: relative;
  height: 100%;
  flex: 1;
  background: #f8f8f8;
  overflow: hidden;
}
/* .scroll-outer::-webkit-scrollbar {
  display: none;
} */
.scroll-body {
  position: absolute;
  height: 100%;
  padding: 0 5px;
  display: inline-block;
  white-space: nowrap;
  transition: left 0.3s ease;
}
.tag-ct {
  display: inline-block;
  height: 34px;
  margin: 3px 8px 3px 0;
  line-height: 31px;
  padding: 0 12px;
  background: #fff;
  cursor: pointer;
  border: 1px solid #e8eaec;
}
.tag-ct:hover {
  opacity: 0.85;
}
.tag-ct.current {
  border: 1px solid #409eff;
}
.dot {
  display: inline-block;
  width: 12px;
  height: 12px;
  margin-right: 3px;
  border-radius: 50%;
  background: #e8eaec;
  position: relative;
  top: 1px;
}
.tag-ct.current .dot {
  background: #409eff;
}
.close {
  display: inline-block;
  width: 15px;
  height: 15px;
  line-height: 15px;
  position: relative;
  top: 1px;
  margin-left: 5px;
  border-radius: 50%;
  text-align: center;
}
.close:hover {
  color: #409eff;
}
.dropDownBtn {
  width: 25px;
  text-align: center;
  background: #fff;
}
.dropDownBtn i {
  font-size: 18px;
  line-height: 40px;
}
</style>
